import { gql } from 'graphql-request';
import { requestWithAuth } from '@/utilities/graphQLClient';

import type { QueryFunctionContext } from '@tanstack/react-query';

export interface CompanyPriceTargetHistory {
  priceTargetHistory: {
    fromDate: number | null;
    toDate: number | null;
    consensusMean: number | null;
    currencyISO: string;
  }[];
}

export type QueryResponse =
  | { errors: Error[] }
  | { Company: CompanyPriceTargetHistory };

export const queryFn = async ({
  queryKey: [_keyof, id, size],
}: QueryFunctionContext<[string, string, number | undefined]>) => {
  const response = await requestWithAuth<QueryResponse>(
    gql`
      query getCompanyPriceTargetHistory($id: String!, $size: Int) {
        Company(id: $id) {
          priceTargetHistory(size: $size) {
            fromDate
            toDate
            consensusMean
            currencyISO
          }
        }
      }
    `,
    { id, size }
  );

  if ('Company' in response) {
    return response.Company;
  }

  const firstErrorMessage = response.errors[0]?.message;
  throw new Error(
    firstErrorMessage ?? 'Failed to fetch Company Price Target History'
  );
};
